import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import {addPopup, setCarResults} from "../../redux/actions";
import * as popups from "../../constants/popup-types";


class CarRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'Car Request';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getCar, payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(setCarResults(this.response.data));
    }

    onFailure(response, methodName = '') {
        this.dispatch(addPopup({
            type:popups.GENERAL_MESSAGE,
            text: response.err.content,
            popup_id: Math.round(Math.random() * 1000000)
        }));
    }
}

export default CarRequest;